export default __webpack_public_path__ + "static/media/FF-Logo.ea4fe44f.png";